module.exports = __webpack_public_path__ + "img/swine-promote-name.48b43334.png";